__turbopack_context__.v({
  "continueButton": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__continueButton",
  "dateTimeSection": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__dateTimeSection",
  "header": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__header",
  "infoText": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__infoText",
  "modal": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__modal",
  "schedulePreOrderTitle": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__schedulePreOrderTitle",
  "timeTiles": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__timeTiles",
  "wrapper": "NewOrderTimeConfigureModal-module-scss-module__FqJLXG__wrapper",
});
